import React from "react";
import { Box, Typography } from "@mui/material";
import {
    ACCOUNT_PAGE_MAIN_CONTENT_SX,
    ACCOUNT_PAGE_SECTION_HEADER_SX,
    ACCOUNT_PAGE_SECTION_SX,
    ACCOUNT_PAGE_TITLE_SX,
} from "./accountPageStyles";

export default function MyReportsPage() {
    return (
        <Box sx={ACCOUNT_PAGE_MAIN_CONTENT_SX}>
            <Box sx={ACCOUNT_PAGE_SECTION_SX}>
                <Box sx={ACCOUNT_PAGE_SECTION_HEADER_SX}>
                    <Typography component="h1" sx={ACCOUNT_PAGE_TITLE_SX}>
                        My reports
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
}
